import { IconButton, InputAdornment, TextField, Box, Typography } from '@mui/material'
import { Visibility, VisibilityOff, CheckCircle, Cancel } from '@mui/icons-material'
import { useState } from 'react'
import { SecretValidationResult } from '@src/tools/key-vault/types/KeyVault'

interface ValidateSecretRowProps {
  secretName: string
  value: string
  onChange: (value: string) => void
  disabled: boolean
  result?: SecretValidationResult
}

const ValidateSecretRow = ({ secretName, value, onChange, disabled, result }: ValidateSecretRowProps) => {
  const [showValue, setShowValue] = useState(false)

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 1 }}>
      <Typography sx={{ minWidth: 250, fontFamily: '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace', fontSize: '0.875rem' }}>{secretName}</Typography>
      <TextField
        value={value}
        onChange={(e) => onChange(e.target.value)}
        size="small"
        fullWidth
        type={showValue ? 'text' : 'password'}
        disabled={disabled}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => setShowValue(!showValue)} edge="end">
                  {showValue ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
      <Box sx={{ width: 32, display: 'flex', justifyContent: 'center' }}>
        {result && (result.match ? <CheckCircle color="success" /> : <Cancel color="error" />)}
      </Box>
    </Box>
  )
}

export default ValidateSecretRow
